const Mode = {
  Present: 'present',
  Explore: 'explore',
  Assess: 'assess'
};

export default Mode;